// extracted by mini-css-extract-plugin
module.exports = {"container":"_35cENlaf7zE7TwxNIyGYyD","groupsList":"ZiwhBAmt3oeZVb7n9-Wp_"};